import script from "./EvidenciasInstrumentosView.vue?vue&type=script&lang=ts&setup=true"
export * from "./EvidenciasInstrumentosView.vue?vue&type=script&lang=ts&setup=true"

import "./EvidenciasInstrumentosView.vue?vue&type=style&index=0&id=37fc6de9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37fc6de9"]])

export default __exports__